/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ImagePlaceholder/view.blocks to change it.
import * as fromData from 'Simple/Data'
import ImageCard from 'DesignSystem/ImageCard/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function ImagePlaceholder({
  children,
  viewPath = "/DesignSystem/ImageViewGrid/ImageGrid/ImageSlot/ImagePlaceholder"
  
}) {
let gridLayoutValueData = fromData.useDataValue({ viewPath,
context: 'grid',
path: 'layout',
})
let gridImageSeriesIdValueData = fromData.useDataValue({ viewPath,
context: 'grid',
path: 'image_series_id',
})
let gridImagesLengthValueData = fromData.useDataValue({ viewPath,
context: 'grid',
path: 'images.length',
})
let imageSlotDefinitionValueData = fromData.useDataValue({ viewPath,
context: 'image_slot',
path: 'definition',
})
let imageSlotItemIndexReverseValueData = fromData.useDataValue({ viewPath,
context: 'image_slot_item',
path: 'indexReverse',
})
  return (<React.Fragment
>
<ImageCard
  viewPath={`${viewPath}/ImageCard`}
 data="grid.layout"
 layout={gridLayoutValueData}
 data="grid.image_series_id"
 imageSeriesId={gridImageSeriesIdValueData}
 data="grid.images.length"
 imagesLength={gridImagesLengthValueData}
 data="image_slot.definition"
 imageDefinition={imageSlotDefinitionValueData}
 data="image_slot_item.indexReverse"
 itemIndexReverse={imageSlotItemIndexReverseValueData}
/>
{children}
</React.Fragment>)
}